import { LitElement, html, css } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { VoyageCheckbox } from '../../voyage-checkbox/src/voyage-checkbox';
import '../../voyage-checkbox/src/voyage-checkbox';
import { UiStateModel, UiStateModelParam } from '../../../src/models/ui-state-model';
import { VesselsModel } from '../../../src/models/vessels-model';

export const layerNames = [ "Lat Long", "Whale zones (All)", "Whale Zones In Force",  "ECA/SECA", "Marpol", "Security zones", "Terminal geofences"] as const;
export type ShoreLayers = typeof layerNames[number];

@customElement('shore-map-layers-selector')
export class ShoreMapLayerSelector extends LitElement {
    @property({type: Boolean}) shown: boolean = false;
    
    constructor() {
        super();
        this.onVesselLoadingComplete = this.onVesselLoadingComplete.bind(this);
    }
    
    static get styles() {
        return [
            css`
            :host {
                display: none;
            }

            :host([shown]) {
                display: flex;
            }

            .container {
                font-family: 'MaerskText';
                font-size: 14px;
                background: var(--neutrals-grey-10);
                border: 1px solid var(--neutrals-grey-7);
                border-radius: 3px;
                display: grid;
                grid-gap: 12px;
                grid-template-rows: auto, auto;
                width: 100%;
                padding-bottom: 24px;
            }
        `];
    }

    render() {
        return html`
            <div class="container">
                ${layerNames.map(name => this.renderCheckbox(name))}
            </div>
        `;
    }

    firstUpdated() {
        UiStateModel!.setValue(UiStateModelParam.SelectedMapLayer); 
    }

    connectedCallback(): void {
        VesselsModel!.addEventListener('vessels-loaded', this.onVesselLoadingComplete);
        super.connectedCallback();
    }

    disconnectedCallback(): void {
        VesselsModel!.addEventListener('vessels-loaded', this.onVesselLoadingComplete);
        super.disconnectedCallback();
    }

    onVesselLoadingComplete(){
        layerNames.forEach(item => {
            let id = item.replace(/ /g, "-");
            let element = <HTMLInputElement>this.shadowRoot!.getElementById(id);
            this.dispatchEvent(new CustomEvent('selection-changed', {detail: { layer: item, value: element.checked }}));
        });
    }

    renderCheckbox(name: ShoreLayers) {
        return html`
            <voyage-checkbox label=${name} id=${name.replace(/ /g, "-")}
                    @input=${(evt:InputEvent) => this.dispatchSelectionEvent(name,(<VoyageCheckbox>evt.target).checked)}>
            </voyage-checkbox>
        `
    }

    dispatchSelectionEvent(name: ShoreLayers, changedValue: boolean) {
        this.dispatchEvent(new CustomEvent('selection-changed', {detail: { layer: name, value: changedValue }}));
    }
};
